import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Button } from '@/src/domains/design-system/components/Button'
import { useSelfAssessmentWizard } from '@/src/domains/self-assessments/components/SelfAssessmentWizard/SelfAssessmentWizard.context'

export const SelfAssessmentWizardQuestionActions = () => {
  const { t } = getTranslate()
  const { isLastQuestion, handleBack } = useSelfAssessmentWizard()

  return (
    <div className="flex flex-col-reverse justify-between gap-4 tablet:flex-row">
      <Button type="button" size="medium" variant="secondary" onClick={handleBack}>
        {t('component.button.back')}
      </Button>

      <Button type="submit" size="medium">
        {isLastQuestion ? t('general.show') : t('component.button.continue')}
      </Button>
    </div>
  )
}
